import { MAX_SPACE_ICONS_BATCH_SIZE } from '#pplx/frontend/apps/ask/queries/spaces-queries/constants.js';
/**
 * Coalesces same-tick load(id) calls into one batch request (flushed on a
 * microtask, so every load from the same render commit joins the batch).
 * Loads arriving while a flush is in flight start the next batch. Ids missing
 * from the response resolve null — the endpoint omits unknown ids by contract.
 */
export function createSpaceIconBatcher(fetchBatch) {
    let pending = new Map();
    let flushScheduled = false;
    const flush = async () => {
        const batch = pending;
        pending = new Map();
        flushScheduled = false;
        const ids = [...batch.keys()];
        const chunks = [];
        for (let start = 0; start < ids.length; start += MAX_SPACE_ICONS_BATCH_SIZE) {
            chunks.push(ids.slice(start, start + MAX_SPACE_ICONS_BATCH_SIZE));
        }
        await Promise.all(chunks.map(async (chunk) => {
            try {
                const icons = await fetchBatch(chunk);
                const iconsById = new Map(icons.map((icon) => [icon.id, icon]));
                for (const id of chunk) {
                    batch.get(id)?.resolve(iconsById.get(id) ?? null);
                }
            }
            catch (error) {
                for (const id of chunk) {
                    batch.get(id)?.reject(error);
                }
            }
        }));
    };
    return {
        load(id) {
            const existing = pending.get(id);
            if (existing) {
                return existing.promise;
            }
            let resolve;
            let reject;
            const promise = new Promise((res, rej) => {
                resolve = res;
                reject = rej;
            });
            const pendingLoad = { promise, resolve, reject };
            pending.set(id, pendingLoad);
            if (!flushScheduled) {
                flushScheduled = true;
                queueMicrotask(() => void flush());
            }
            return pendingLoad.promise;
        },
    };
}
//# sourceMappingURL=spaceIconBatcher.js.map